import React from 'react';
import Tooltip, { type TooltipProps } from '@atlaskit/tooltip';

type Props = TooltipProps & {
	condition: boolean;
};

export const ConditionalTooltip = ({ condition, children, ...rest }: Props): React.JSX.Element =>
	// @ts-expect-error - TS2322 Typescript 5.9.2 upgrade
	condition ? <Tooltip {...rest}>{children}</Tooltip> : <>{children}</>;
